import axios from 'axios'

// const API_BASE_URL = 'https://upskledbackend.vercel.app'
const API_BASE_URL = 'https://upskld.co/api'

export const getStoredUser = () => {
  try {
    const raw = localStorage.getItem('user') || sessionStorage.getItem('user')
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

export const getCurrentUserId = () => {
  const user = getStoredUser()
  return user?.id || user?._id || null
}

// Records a video watch milestone for a module inside a specific course
// section. e.g. updateModuleProgress('DroneSection', 2, 40)
export const updateModuleProgress = async (section, moduleId, percent) => {
  const userId = getCurrentUserId()
  if (!userId) return null

  try {
    const response = await axios.post(`${API_BASE_URL}/skills/progress`, {
      userId,
      section,
      moduleId,
      percent,
    })
    return response.data
  } catch (error) {
    console.error('Failed to update module progress:', error.message)
    return null
  }
}

// Full progress for a user — every course section on their one document,
// e.g. { DroneSection: { module1: {...}, ... }, AiSection: { module1: {...}, ... } }
export const fetchUserSkills = async (userId) => {
  if (!userId) return { DroneSection: {}, AiSection: {} }

  try {
    const response = await axios.get(`${API_BASE_URL}/skills/${userId}`)
    return response.data?.data || { DroneSection: {}, AiSection: {} }
  } catch (error) {
    console.error('Failed to fetch skills:', error.message)
    return { DroneSection: {}, AiSection: {} }
  }
}

// Progress for just one course section — used by that course's CoursePage.
// Returns { module1: { percent, completed }, module2: {...}, ... }
export const fetchSectionSkills = async (userId, section) => {
  if (!userId) return {}

  try {
    const response = await axios.get(`${API_BASE_URL}/skills/${userId}/${section}`)
    return response.data?.data || {}
  } catch (error) {
    console.error('Failed to fetch section skills:', error.message)
    return {}
  }
}